export const SHOWN_EVENT_MODALS_KEY = 'eventModalDates';
